import React, { Fragment } from 'react';
import styles from './CheckGroup.module.css';
import CheckBox from 'rc-checkbox';
import Divider from '../Divider';

let values = [];
const CheckGroup = ({
  title,
  options,
  selectedOptions,
  onChange,
  creatNew,
  keyLetter,
  toggleModal,
  required,
}) => {
  const onChangeHandler = (e, op) => {
    const { value } = op;
    values = selectedOptions || [];
    const checked = e.target.checked;
    if (checked) {
      if (values.length === 0 || !values.includes(value)) {
        values.push(value);
      }
    } else {
      if (values.includes(value)) {
        const index = values.indexOf(value);
        values.splice(index, 1);
      }
    }
    onChange(keyLetter, values);
  };
  return (
    <div className={styles.container}>
      <p className={styles.title}>
        {title}
        {required && <span className={styles.required}>required</span>}
      </p>
      <ul className={styles.lists}>
        {options &&
          options.map(op => (
            <li className={styles.list} key={op.value}>
              <CheckBox
                onChange={e => onChangeHandler(e, op)}
                checked={selectedOptions && selectedOptions.includes(op.value)}
              />
              &nbsp; {op.label}
            </li>
          ))}{' '}
        {creatNew && (
          <Fragment>
            <Divider style={{ width: '100%' }} />
            <div className={styles.link} onClick={e => toggleModal(true)}>
              Create new tag
            </div>
          </Fragment>
        )}
      </ul>
    </div>
  );
};

export default CheckGroup;



// WEBPACK FOOTER //
// ./src/components/CheckGroup/index.js